import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { requirePin } from '../actions'
import { requirePinForManageProfile } from '../lib/account'
import { isPinValid } from '../lib/pin'

/**
 * Handles the initial PIN gate for protected profile screens.
 * After account data is loaded, the hook checks whether manage-profile actions
 * require a PIN and whether the current PIN is already valid.
 */

export const useRequirePin = (account, onValidPin) => {
  const dispatch = useDispatch()
  const hasValidPin = useSelector(state => isPinValid(state))
  const hasCheckedPin = useRef(false)
  const isPinRequired = Boolean(
    account &&
    !hasValidPin &&
    requirePinForManageProfile(account)
  )

  useEffect(() => {
    // Wait for account data, then make only one PIN decision per mount.
    if (!account || hasCheckedPin.current) {
      return
    }

    hasCheckedPin.current = true

    if (isPinRequired) {
      dispatch(requirePin(onValidPin))
    }
  }, [account, dispatch, isPinRequired, onValidPin])

  return isPinRequired
}

export default useRequirePin
